import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M9 15h1v1H9v-1z',
    'M13.597 2C14.369 2 15 2.665 15 3.477v13.046c0 .812-.631 1.477-1.403 1.477H5.403C4.631 18 4 17.335 4 16.523V3.477C4 2.665 4.631 2 5.403 2h8.194zM14 16.523V14H5v2.523c0 .258.184.477.403.477h8.194c.219 0 .403-.219.403-.477zM5 13h9V5H5v8zm9-9v-.523c0-.258-.184-.477-.403-.477H5.403C5.184 3 5 3.219 5 3.477V4h9z',
  ],
  height: 20,
  width: 20,
});
